export const fundingTypeEnum = {
    Lease: "lease",
    Particulier: "particulier",
    Self: "self",
    Unknown: "unknown",
} as const;
